























import { Vue, Component, Prop } from "vue-property-decorator";
import ScenePreview from "@/components/ScenePreview.vue";
import ConfigurationMenu from "@/components/ConfigurationMenu.vue";
import ConfigurationSideMenu from "@/components/ConfigurationSideMenu.vue";
import ComponentsList from "@/components/ComponentsList.vue";
import { ItemSection, IItemSection } from "@/models/itemSection";
import { ItemParams } from "@/models/itemParams";
import Cell from "@/models/cell";
import { ISectionCreator, SectionCreator } from "@/models/sectionCreator";

@Component({
  components: {
    ScenePreview,
    ConfigurationMenu,
    ConfigurationSideMenu,
    ComponentsList
  }
})
export default class SchemesList extends Vue {
  @Prop({ type: Boolean, required: true }) visibility!: Boolean;

  componentsListVisibility = false;

  sections: IItemSection[] = [];
  sectionCreator: ISectionCreator = new SectionCreator();

  sceneStyle = {};
  canvasStyle = {};

  mounted() {
    this.setupStyle();
    window.addEventListener("resize", () => {
      this.setupStyle();
    });
    this.sectionCreator.onSectionsChanged.on(sections => {
      this.sections = sections;
    });
    this.sectionCreator.initialize(this.$refs["scene-preview"]);
  }

  private setupStyle() {
    if (window.innerWidth > 960) {
      this.sceneStyle = { height: "600px" };
      this.canvasStyle = { height: "600px" };
    } else {
      this.sceneStyle = {};
      this.canvasStyle = {};
    }
  }

  private openComponentsList(cells: Cell[]) {
    console.log(cells);
    const meshes = cells.map(x => x.mesh);
    this.sectionCreator.create(meshes);
  }
}
